<template lang="pug">
    v-layout(wrap class="menu")
        v-flex(lg12 md12 xs12 v-if="listData && listData.length > 0")
            v-data-table(
                hide-default-footer
                :headers="headers" 
                :loading="loading"
                loading-text="Proses mengambil data ....."
                no-data-text="Data tidak ditemukan ....."
                no-results-text="Data tidak ditemukan ....."
                :items="listData"
                :page.sync="page"
                :items-per-page="itemsPerPage"
                @page-count="pageCount = $event"
                :search="criteria"
            )
                template(v-slot:top)
                    v-container(grid-list-md)
                        v-layout(wrap)
                            v-spacer
                            v-flex(lg5 md5 xs12)
                                v-text-field(dense v-model="criteria" label="Filter Data Pencarian" prepend-icon="mdi-magnify" class="mx-2" clearable)
                template(v-slot:item.installmentAmount="{item}")
                    div {{ item.amount | decimalformat }}
                                
            div(class="text-xs-center ma-2")
                v-pagination(v-model="page" :length="pageCount")
        v-flex(lg12 md12 xs12 v-else)
            v-layout(wrap justify-center text-center class="font-weight-bold pa-3 blue lighten-4" )
                div No. Installment ini belum pernah melakukan pembayaran
</template>
<script>
export default {
    name: 'FInstallmentDetailTable',
    props: ["listDetail"],
    data() {
        return {
            listData: [],
            listGroup: [],
            loading: false,
            criteria: "",
            headers: [
                {text: 'NO. INSTALLMENT DETAIL', value: 'installmentDetailId', sortable: false, align: "center", width: "50%", class: "primary--text"},
                {text: 'STATUS', value: 'statusName', sortable: false, align: "center", width: "20%", class: "primary--text"},
                {text: 'NOMINAL', value: 'installmentAmount', sortable: false, width: "30%", align:"right", class: "primary--text"},
            ],
            page: 1,
            itemsPerPage: 5,
            pageCount: 0,
        }
    },
    watch: {
        listDetail(val){
            this.doLoad(val);
        }
    },
    mounted() {
        this.doLoad(this.listDetail);
    },
    methods: {
        doLoad(values){
            this.listData = values ? values : [];
        }
    },
}
</script>